import {
    CPPRODUCT_SEARCH,
    CPPRODUCT_LOADING,
    CPPRODUCT_CREATED,
    CPPRODUCT_DELETED,
    CPPRODUCT_LOADED,
    CPPRODUCT_EDITED,
    CPPRODUCT_FAILED,
    CPPRODUCT_DETAILS,
    PRODUCTTOKEN_LOADING,
    PRODUCTTOKEN_DELETED,
    PRODUCTTOKEN_EDITED,
    PRODUCTTOKEN_ADDED,
    PRODUCTTOKEN_FAILED,
    PRODUCTACCESS_LOADING,
    PRODUCTACCESS_DELETED,
    PRODUCTACCESS_EDITED,
    PRODUCTACCESS_ADDED,
    PRODUCTACCESS_FAILED,
    PRODUCTEVENT_LOADING,
    PRODUCTEVENT_LOADED,
    PRODUCTEVENT_CREATED,
    PRODUCTEVENT_EDITED,
    PRODUCTEVENT_DELETED,
    PRODUCTEVENT_FAILED,
    NETWORKPRODUCT_LOADING,
    NETWORKPRODUCT_LOADED,
    NETWORKPRODUCT_CREATED,
    NETWORKPRODUCT_EDITED,
    NETWORKPRODUCT_DELETED,
    NETWORKPRODUCT_FAILED,
    ALPHATAG_LOADING,
    ALPHATAG_LOADED,
    ALPHATAG_FAILED,
    ALPHATAG_DELETED,
    ALPHATAG_EDITED,
    ALPHATAG_CREATED,
    PRODUCTSELECTED,
    COMPANYSELECTED,
    LOGOUT,
    ALPHATAG_SEARCHRESET,
    ALPHATAG_SEARCH,
    PRODUCTCONTENT_LOADED,
    PRODUCTCONTENT_LOADING,
    PRODUCTCONTENT_SEARCH,
    PRODUCTCONFIG_LOADED,
    PRODUCTCONFIG_FAILED,
    PRODUCTCONTENT_FAILED,
    PRODUCTCONTENT_EDITED,
    PRODUCTCONTENT_CREATED,
    PRODUCTCONTENT_DELETED,
    ALPHATAG_ALLOCATED,
    ALPHATAG_DEALLOCATED,
    ALPHATAG_COMPANY_LOADED,
    ALPHATAG_COMPANY_SEARCH,
} from "../types";

import {
    created,
    editedUpdate,
    editPaginated,
    deleteFromState,
    deletePaginated,
} from "../../helpers/reduxUtils";

const initialState = {
    tokenLoading: false,
    accessLoading: false,
    loading: false,
    products: null,
    product: null,
    tokens: null,
    accessCodes: null,
    searchResults: null,
    tags: [],
    taggedSP: [],
    searchTags: null,
    searchTaggedSP: null,
    events: [],
    networks: [],
    success: false,
    config: null,
    content: [],
    searchContent: [],
    companySelected: localStorage.getItem("selectedCompany"),
    productSelected: localStorage.getItem("selectedProduct"),
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PRODUCTCONTENT_EDITED:
            return {
                ...state,
                loading: false,
                searchContent: editedUpdate(state.searchContent, action.payload),
                content: editedUpdate(state.content, action.payload),
            };
        case ALPHATAG_COMPANY_SEARCH:
            return {
                ...state,
                loading: false,
                searchTaggedSP: action.payload,
            };
        case ALPHATAG_COMPANY_LOADED:
            return {
                ...state,
                loading: false,
                taggedSP: action.payload,
            };
        case ALPHATAG_DEALLOCATED:
            return {
                ...state,
                loading: false,
                taggedSP: deleteFromState(state.taggedSP, action.payload),
            };
        case ALPHATAG_ALLOCATED:
            return {
                ...state,
                loading: false,
                taggedSP: created(state.taggedSP, action.payload),
            };
        case PRODUCTCONTENT_CREATED:
            return {
                ...state,
                loading: false,
                content: created(state.content, action.payload),
            };
        case PRODUCTCONTENT_DELETED:
            return {
                ...state,
                loading: false,
                searchContent: deleteFromState(state.searchContent, action.payload),
                content: deleteFromState(state.content, action.payload),
            };

        case PRODUCTCONTENT_SEARCH:
            return {
                ...state,
                loading: false,
                searchContent: action.payload,
            };
        case PRODUCTCONTENT_LOADED:
            return {
                ...state,
                loading: false,
                content: action.payload,
            };
        case PRODUCTCONTENT_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PRODUCTCONFIG_LOADED:
            return {
                ...state,
                loading: false,
                config: action.payload,
            };
        case PRODUCTCONFIG_FAILED:
            return {
                ...state,
                loading: false,
            };
        case PRODUCTCONTENT_FAILED:
            return {
                ...state,
                loading: false,
                config: null,
            };
        case COMPANYSELECTED:
            localStorage.setItem("selectedCompany", action.payload.companyName);
            return {
                ...state,
                companySelected: action.payload.companyName,
            };
        case PRODUCTSELECTED:
            localStorage.setItem("selectedProduct", action.payload.title);
            return {
                ...state,
                productSelected: action.payload.title,
            };
        case ALPHATAG_SEARCHRESET:
            return {
                ...state,
                loading: false,
                searchTags: null,
                searchTaggedSP: null,
            };
        case ALPHATAG_SEARCH:
            return {
                ...state,
                loading: false,
                searchTags: action.payload,
            };
        case ALPHATAG_DELETED:
            return {
                ...state,
                loading: false,
                tags: deleteFromState(state.tags, action.payload),
            };
        case ALPHATAG_EDITED:
            return {
                ...state,
                loading: false,
                tags: editedUpdate(state.tags, action.payload),
            };
        case ALPHATAG_CREATED:
            return {
                ...state,
                loading: false,
                tags: created(state.tags, action.payload),
            };
        case ALPHATAG_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ALPHATAG_LOADED:
            return {
                ...state,
                loading: false,
                tags: action.payload,
            };
        case PRODUCTACCESS_DELETED:
            return {
                ...state,
                accessLoading: false,
                accessCodes: deleteFromState(state.accessCodes, action.payload),
            };
        case PRODUCTACCESS_EDITED:
            return {
                ...state,
                accessLoading: false,
                accessCodes: editedUpdate(state.accessCodes, action.payload),
            };
        case PRODUCTACCESS_ADDED:
            return {
                ...state,
                accessLoading: false,
                accessCodes: created(state.accessCodes, action.payload),
            };
        case PRODUCTACCESS_LOADING:
            return {
                ...state,
                accessLoading: true,
            };
        case PRODUCTTOKEN_LOADING:
            return {
                ...state,
                tokenLoading: true,
            };
        case PRODUCTEVENT_DELETED:
            return {
                ...state,
                loading: false,
                events: deleteFromState(state.events, action.payload),
            };
        case PRODUCTEVENT_EDITED:
            return {
                ...state,
                loading: false,
                events: editedUpdate(state.events, action.payload),
            };
        case PRODUCTEVENT_CREATED:
            return {
                ...state,
                loading: false,
                events: created(state.events, action.payload),
            };
        case PRODUCTEVENT_LOADED:
            return {
                ...state,
                loading: false,
                events: action.payload,
            };
        case NETWORKPRODUCT_DELETED:
            return {
                ...state,
                loading: false,
                networks: deleteFromState(state.networks, action.payload),
            };
        case NETWORKPRODUCT_EDITED:
            return {
                ...state,
                loading: false,
                networks: editedUpdate(state.networks, action.payload),
            };
        case NETWORKPRODUCT_CREATED:
            return {
                ...state,
                loading: false,
                // networks: created(state.networks, action.payload),
                networks: [...state.networks, ...action.payload],
            };
        case NETWORKPRODUCT_LOADED:
            return {
                ...state,
                loading: false,
                networks: action.payload,
            };
        case NETWORKPRODUCT_LOADING:
        case PRODUCTEVENT_LOADING:
        case CPPRODUCT_LOADING:
            return {
                ...state,
                success: false,
                loading: true,
            };
        case CPPRODUCT_CREATED:
            return {
                ...state,
                token: [],
                accessCodes: [],
                success: true,
                loading: false,
                product: action.payload,
            };
        case CPPRODUCT_EDITED:
            return {
                ...state,
                success: true,
                loading: false,
                product: action.payload,
                products: editPaginated(state.products, action.payload),
            };
        case CPPRODUCT_DELETED:
            return {
                ...state,
                loading: false,
                products: deletePaginated(state.products, action.payload),
            };
        case CPPRODUCT_LOADED:
            return {
                ...state,
                token: null,
                product: null,
                success: false,
                loading: false,
                products: action.payload,
            };
        case CPPRODUCT_DETAILS:
            return {
                ...state,
                loading: false,
                tokens: action.payload.tokens,
                product: action.payload.product,
                accessCodes: action.payload.accessCodes,
            };
        case CPPRODUCT_SEARCH:
            return {
                ...state,
                loading: false,
                searchResults: action.payload,
            };
        case PRODUCTTOKEN_ADDED:
            return {
                ...state,
                tokenLoading: false,
                tokens: created(state.tokens, action.payload),
            };
        case PRODUCTTOKEN_EDITED:
            return {
                ...state,
                tokenLoading: false,
                tokens: editedUpdate(state.tokens, action.payload),
            };
        case PRODUCTTOKEN_DELETED:
            return {
                ...state,
                tokenLoading: false,
                tokens: deleteFromState(state.tokens, action.payload),
            };
        case PRODUCTTOKEN_FAILED:
            return {
                ...state,
                tokenLoading: false,
            };
        case PRODUCTACCESS_FAILED:
            return {
                ...state,
                accessLoading: false,
            };
        case ALPHATAG_FAILED:
        case NETWORKPRODUCT_FAILED:
        case PRODUCTEVENT_FAILED:
        case CPPRODUCT_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        case LOGOUT:
            localStorage.removeItem("selectedCompany");
            localStorage.removeItem("selectedProduct");
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
